/* ============================================================
   DIETMONSTA · Address book — delete via fetch, not navigation

   Dawn's own CustomerAddresses class (customer.js, reused unmodified for
   the toggle buttons and country/province cascade) deletes an address by
   calling Shopify.postLink(), which builds a real <form> and navigates
   the browser to it. Shopify's delete-address endpoint issues its own
   post-action redirect once it's done — and that redirect target is the
   hosted new-customer-accounts UI, not wherever the request came from.
   A real navigation always follows that redirect.

   fetch() doesn't have that problem: it follows the redirect internally
   to get the final response, but never touches window.location itself.
   So the delete happens (same URL, same _method=delete body Dawn's own
   code already used), and the browser just stays on this page — we
   decide what happens next (a reload), not Shopify's redirect target.

   This only handles the delete button. The add/edit forms' own
   navigation apparently already redirects back here correctly (no
   report otherwise), and the toggle/country-cascade behaviour stays on
   customer.js — this file intentionally does not touch those. The
   delete buttons carry data-dm-delete-* attributes instead of Dawn's
   data-target / data-confirm-message specifically so customer.js's own
   [data-confirm-message] selector never matches them — otherwise both
   handlers would fire.
   ============================================================ */

class DmAddresses extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-dm-delete-url]');
      if (!btn) return;
      event.preventDefault();
      const message = btn.dataset.dmDeleteConfirm || 'Delete this address?';
      // eslint-disable-next-line no-alert
      if (!window.confirm(message)) return;
      this.#deleteAddress(btn);
    });
  }

  async #deleteAddress(btn) {
    btn.disabled = true;
    try {
      const res = await fetch(btn.dataset.dmDeleteUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ _method: 'delete' }),
      });
      if (res.ok) {
        window.location.reload();
        return;
      }
      throw new Error(`Delete failed: ${res.status}`);
    } catch (err) {
      btn.disabled = false;
      // eslint-disable-next-line no-alert
      window.alert('Could not delete that address — try again.');
    }
  }
}

if (!customElements.get('dm-addresses')) {
  customElements.define('dm-addresses', DmAddresses);
}
